import { useEffect } from "react"
import { Form, FormikErrors, useFormikContext } from "formik"

type StandardFormikErrorScrollWrapperProps<T> = {
    children: React.ReactNode
}

function findFirstErrorField<T>(errors: FormikErrors<T>, prefix = ""): string | undefined {
    for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
            const errorValue = errors[key]
            const fieldPath = prefix ? `${prefix}.${key}` : key

            if (
                typeof errorValue === "object" &&
                errorValue !== null &&
                !Array.isArray(errorValue) &&
                Object.keys(errorValue).length > 0
            ) {
                return findFirstErrorField(errorValue, fieldPath)
            } else if (errorValue) {
                return fieldPath
            }
        }
    }
    return undefined
}

export function StandardFormikErrorScrollWrapper<T>({ children }: StandardFormikErrorScrollWrapperProps<T>) {
    const { errors, isSubmitting, isValidating } = useFormikContext<T>()

    useEffect(() => {
        if (Object.keys(errors).length > 0 && isSubmitting) {
            const firstErrorField = findFirstErrorField(errors)
            if (firstErrorField) {
                const errorElementByName = document.querySelector(`[name="${firstErrorField.replace(/\./g, "\\.")}"]`)
                if (errorElementByName) {
                    errorElementByName.scrollIntoView({ behavior: "smooth", block: "center" })
                } else {
                    const errorElementById = document.getElementById(firstErrorField)
                    if (errorElementById) {
                        errorElementById.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                }
            }
        }
    }, [errors, isSubmitting, isValidating])

    return <Form>{children}</Form>
}
